<template>
    <teleport to="head">
        <meta name="title" :content="entry.title"/>
        <meta name="description" :content="entry.description"/>
    </teleport>
    <div class="post-outer-wrap">
        <div class="post-wrap">
            <h1>{{entry.title}}</h1>
            <div class="article-meta">
                <p v-if="entry.date"><small><fa-icon :icon="['fas', 'calendar']"/> {{formatDate(entry.date)}}</small></p>
                <p v-if="entry.tags"><small><fa-icon :icon="['fas', 'tag']"/> {{entry.tags}}</small></p>
            </div>
            <component v-if="finishedLoading" :is="component"></component>
        </div>
    </div>
</template>

<script>
    import formatDate from '@/helpers/formatDate'
    import 'highlight.js/styles/atom-one-dark.css';

    // Body-free front matter for post headers: the `!!` inline loader reads only
    // the YAML front matter, so looking a post up here never pulls in its body.
    const frontmatterContext = require.context('!!../../mdFrontmatterLoader.js!../markdown', false, /\.md$/)

    export default {
        name: "BlogProjectsSingle",
        components: {
        },
        data () {
            return {
                component: 'SingleBlog',
                finishedLoading: false,
                entry: {},
            }
        },
        watch: {
            $route(to, from) {
                this.loadDynamicComponent()
            }
        },
        computed: {
            postSlug () {
                return this.$route.params.slug
            }
        },
        methods: {
            formatDate,
            loadFrontmatter (slug) {
                try {
                    return frontmatterContext('./' + slug + '.md').default || {}
                } catch (e) {
                    return {}
                }
            },
            loadDynamicComponent () {
                if (!this.postSlug) return;
                this.finishedLoading = false
                import('@/markdown/' + this.postSlug + '.md')
                    .then(component => {
                        this.$options.components[this.component] = component.default
                        this.entry = this.loadFrontmatter(this.postSlug)
                        this.finishedLoading = true
                    })
                    .catch(e => {
                        this.$router.push({
                            name: 'LostAndFound'
                        })
                    })
            }
        },
        mounted () {
            this.loadDynamicComponent()
        }
    }
</script>

<style lang="scss">
    .post-outer-wrap {
        background: #222222;

        .post-wrap {
            background: white;
            margin: auto;
            max-width: 850px;
            padding: 15px 15px 50px 15px;

            .article-meta {
                p { margin: 0;}
            }

            p, li {
                line-height: 1.6em;
                font-size: 1.1em;
            }
        }
    }
</style>